import { ConfirmationDialog, showToast } from '@solinkcorp/solink-ui';
import {
  useArchivePanelActions,
  type ArchiveNotifier,
  type ArchivePanelProps,
} from './useArchivePanelActions';

const archiveNotifier: ArchiveNotifier = {
  success: (message, options) => {
    showToast.success(
      { title: message },
      options === undefined ? undefined : { duration: options.autoClose },
    );
  },
  error: (message) => {
    showToast.error({ title: message });
  },
};

export function ArchivePanelAspen(props: ArchivePanelProps) {
  const {
    onConfirm,
    modalTitle,
    archiveConfirmation,
    infoText,
    eventTitle,
    cancelLabel,
    confirmLabel,
  } = useArchivePanelActions({ ...props, closeArchivePanel: undefined }, archiveNotifier);

  return (
    <ConfirmationDialog
      open={Boolean(props.archivePanelOpen)}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) {
          props.closeArchivePanel?.();
        }
      }}
      title={modalTitle}
      description={eventTitle}
      cancelText={cancelLabel}
      confirmText={confirmLabel}
      confirmVariant={props.type === 'archive' ? 'destructive' : 'default'}
      onConfirm={() => onConfirm()}
    >
      <div className="flex flex-col gap-1">
        <p className="text-foreground-primary body-md">{archiveConfirmation}</p>
        {infoText ? <p className="text-foreground-secondary body-sm">{infoText}</p> : null}
      </div>
    </ConfirmationDialog>
  );
}
